const GIFAnimation = (() => {
  const DOM = {};

  const cacheDOM = () => {
    DOM.headerLogo = document.getElementsByClassName("header__logo");
    DOM.gifIcons = document.getElementsByClassName("js-gif-icon");
  };

  const playHeaderGIFAnimation = () => {
    if (!DOM.headerLogo[0]) return;
    if (!DOM.headerLogo[0].getElementsByTagName("img")[0]) return;

    const headerLogoGIF = DOM.headerLogo[0].getElementsByTagName("img")[0];
    const headerLogoGIFSrc = headerLogoGIF.src;

    DOM.headerLogo[0].addEventListener("mouseover", function () {
      headerLogoGIF.src = headerLogoGIFSrc;
    });
  };

  const playGIFIconAnimation = () => {
    if (!DOM.gifIcons) return;

    Array.from(DOM.gifIcons).forEach((icon) => {
      const GIFIconSrc = icon.getAttribute("data-gif");

      icon.addEventListener("mouseover", function () {
        icon.src = GIFIconSrc;
      });
    });
  };

  const init = () => {
    cacheDOM();

    if (DOM.headerLogo) {
      playHeaderGIFAnimation();
    }

    if (DOM.gifIcons) {
      playGIFIconAnimation();
    }
  };

  return { init };
})();

export default GIFAnimation;
